<ng-container *ngIf='!isPublic'>
  <div *carm-acl-group="[carmResourcesEnum.ALERTS, groupTypeEnum.Reader]">
  <ng-container *ngFor='let alert of alerts$ | async'>
    <div class="mrgn-tp-md">
      <carm-alerts-view [alertType]="alert.alertTypeUid" [title]="alert.title" [content]="alert.content" [contentDetailLink]="getAlertDetailLink(alert.containerPageUid)" ></carm-alerts-view>
    </div>
  </ng-container>
  </div>
</ng-container>
<ng-container *ngIf='isPublic'>
  <ng-container *ngFor='let alert of alerts$ | async'>
    <div class="mrgn-tp-md">
      <carm-alerts-view [alertType]="alert.alertTypeUid" [title]="alert.title" [content]="alert.content" [contentDetailLink]="getAlertDetailLink(alert.containerPageUid)" ></carm-alerts-view>
    </div>
  </ng-container>
</ng-container>
<ng-container *ngIf='pageNotification$ | async as pageNotification'>
  <carm-alerts-view [alertType]="pageNotification.type" [title]="pageNotification.title" [content]="pageNotification.text" ></carm-alerts-view>
</ng-container>
<ng-container *ngIf='formErrorNotification$ | async as formErrorNotification'>
  <carm-alerts-view multiple=true [alertType]="formErrorNotification.type" [title]="formErrorNotification.title" [content]="formErrorNotification.formErrors" ></carm-alerts-view>
</ng-container>
